import React from "react"
import { StyledIcon } from "../StyledIcon"

// eslint-disable-next-line import/prefer-default-export
const EmptyCartWmoIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="108"
    height="107"
    viewBox="0 0 108 107"
    fill="none"
  >
    <path
      d="M103.486 24.7857H19.3939C19.3199 24.7857 19.2636 24.8033 19.1943 24.8083C18.8528 23.136 18.5114 21.4637 18.1699 19.7914C17.9924 18.9221 17.9717 17.5482 17.5486 16.7488C16.5725 14.9048 12.9377 14.1737 11.1521 13.4026C8.17057 12.1151 5.18893 10.8277 2.20744 9.54016C0.524279 8.81327 -0.943543 11.2928 0.754432 12.026C3.09285 13.0359 5.43143 14.0456 7.76985 15.0554C10.0021 16.0193 12.5055 17.5666 14.9047 18.2163C14.8908 18.7902 15.1877 19.5468 15.299 20.0918C15.7648 22.3738 16.2307 24.6556 16.6967 26.9375C16.9451 28.1541 17.1935 29.3708 17.442 30.5873V30.602L24.9674 67.458C24.9852 67.8883 25.0736 68.3028 25.2224 68.6921C25.2868 69.0072 25.3511 69.3222 25.4154 69.6371C26.2037 73.4977 26.9919 77.3582 27.7802 81.2188C27.9054 81.8318 28.5676 82.2756 29.1682 82.2756H88.2124H96.5516C98.4041 82.2756 98.407 79.3968 96.5516 79.3968C76.8702 79.3968 57.1888 79.3968 37.5074 79.3968C35.1184 79.3968 32.7295 79.3968 30.3404 79.3968C29.8029 76.7641 29.2654 74.1316 28.7278 71.4989C29.0577 71.5637 29.399 71.6008 29.7501 71.6008H29.7903L94.9075 67.9536L94.9399 67.9512C98.492 67.6704 99.2146 65.6525 99.8935 61.4372L107.999 29.4784V29.2988C107.999 26.8104 105.975 24.7857 103.486 24.7857ZM14.9004 18.1393C14.9003 18.1408 14.9007 18.1427 14.9006 18.1441C14.3804 17.7623 14.9707 17.2068 14.9004 18.1393ZM97.0871 60.7916L97.0611 60.9182C96.4187 64.9304 96.0919 64.9726 94.7304 65.0802L29.7151 68.7216C28.9975 68.7103 28.2558 68.3514 27.9704 67.7892C27.9277 67.5808 27.8853 67.3723 27.8427 67.1639V67.1506L20.3188 30.2996C20.302 29.7127 20.1936 29.1184 20.0883 28.5417C20.0413 28.2816 19.9801 27.9449 19.9449 27.6646H103.486C104.336 27.6646 105.036 28.3165 105.113 29.1465L97.0871 60.7916Z"
      fill="#28465F"
    />
    <path
      d="M53.96 97.861C53.96 93.0665 50.0592 89.166 45.2652 89.166C40.4712 89.166 36.5703 93.0665 36.5703 97.861C36.5703 102.656 40.4712 106.556 45.2652 106.556C50.0592 106.556 53.96 102.656 53.96 97.861ZM39.4492 97.861C39.4492 94.6539 42.0582 92.0449 45.2652 92.0449C48.4723 92.0449 51.0812 94.6539 51.0812 97.861C51.0812 101.068 48.4722 103.677 45.2652 103.677C42.0582 103.677 39.4492 101.068 39.4492 97.861Z"
      fill="#28465F"
    />
    <path
      d="M87.3585 97.861C87.3585 93.0665 83.4576 89.166 78.6636 89.166C73.8695 89.166 69.9688 93.0665 69.9688 97.861C69.9688 102.656 73.8696 106.556 78.6636 106.556C83.4576 106.556 87.3585 102.656 87.3585 97.861ZM72.8476 97.861C72.8476 94.6539 75.4566 92.0449 78.6636 92.0449C81.8708 92.0449 84.4796 94.6539 84.4796 97.861C84.4796 101.068 81.8706 103.677 78.6636 103.677C75.4565 103.677 72.8476 101.068 72.8476 97.861Z"
      fill="#28465F"
    />
    <path
      d="M61.0613 18.6941C61.0777 20.5457 63.9566 20.5502 63.9401 18.6941C63.9054 14.7706 63.8707 10.847 63.8359 6.92358C63.8196 5.07198 60.9407 5.06751 60.9571 6.92358C60.9918 10.847 61.0266 14.7705 61.0613 18.6941Z"
      fill="#28465F"
    />
    <path
      d="M62.4101 0C60.5576 0 60.5545 2.87888 62.4101 2.87888C64.2625 2.87888 64.2655 0 62.4101 0Z"
      fill="#28465F"
    />
    <path
      d="M79.1899 10.7092C76.4401 13.5081 73.6905 16.307 70.9407 19.1058C69.6411 20.4285 71.6753 22.4658 72.9762 21.1415C75.726 18.3426 78.4758 15.5437 81.2255 12.7449C82.525 11.422 80.4909 9.38491 79.1899 10.7092Z"
      fill="#28465F"
    />
    <path
      d="M84.0975 9.30075C85.95 9.30075 85.9529 6.42188 84.0975 6.42188C82.245 6.42188 82.2421 9.30075 84.0975 9.30075Z"
      fill="#28465F"
    />
    <path
      d="M43.6761 12.8319C46.4749 15.5817 49.2737 18.3314 52.0725 21.0812C53.3953 22.3808 55.4325 20.3466 54.1081 19.0455C51.3092 16.2956 48.5105 13.546 45.7116 10.7961C44.3889 9.49655 42.3516 11.5308 43.6761 12.8319Z"
      fill="#28465F"
    />
    <path
      d="M40.828 9.36325C42.6805 9.36325 42.6834 6.48438 40.828 6.48438C38.9755 6.48438 38.9725 9.36325 40.828 9.36325Z"
      fill="#28465F"
    />
    <path
      d="M97.0874 60.7911L97.0615 60.9177C96.419 64.9299 96.0922 64.972 94.7308 65.0796L29.7155 68.7211C28.9978 68.7098 28.2561 68.3509 27.9707 67.7887C27.9281 67.5803 27.8857 67.3718 27.8431 67.1634V67.1501L20.3192 30.299C20.3024 29.7122 20.194 29.1179 20.0887 28.5412C20.0416 28.2811 19.9805 27.9444 19.9453 27.6641H103.486C104.336 27.6641 105.037 28.3159 105.113 29.146L97.0874 60.7911Z"
      fill="#FFCD05"
    />
    <path
      d="M45.2613 103.679C48.4734 103.679 51.0774 101.075 51.0774 97.863C51.0774 94.6508 48.4734 92.0469 45.2613 92.0469C42.0492 92.0469 39.4453 94.6508 39.4453 97.863C39.4453 101.075 42.0492 103.679 45.2613 103.679Z"
      fill="#FFCD05"
    />
    <path
      d="M78.6637 103.679C81.8758 103.679 84.4797 101.075 84.4797 97.863C84.4797 94.6508 81.8758 92.0469 78.6637 92.0469C75.4516 92.0469 72.8477 94.6508 72.8477 97.863C72.8477 101.075 75.4516 103.679 78.6637 103.679Z"
      fill="#FFCD05"
    />
  </svg>
)

export default EmptyCartWmoIcon
